import React from "react";
import Dialog from "@mui/material/Dialog";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTranslation } from "../../hooks/useTranslation";
import "./BonusPolicyDialog.scss";

function formatPercentInPolicyText(text: string, percent: number): string {
  return text.replace(/\{percent\}/g, String(percent));
}

interface BonusPolicyDialogProps {
  open: boolean;
  onClose: () => void;
  dailyWagerReleasePercent: number;
}

const BonusPolicyDialog: React.FC<BonusPolicyDialogProps> = ({
  open,
  onClose,
  dailyWagerReleasePercent,
}) => {
  const { t } = useTranslation();

  const policyKey = (key: string) => `wallet.bonusPolicy.${key}`;

  const getPolicyTextWithPercent = (key: string) =>
    formatPercentInPolicyText(t(policyKey(key)), dailyWagerReleasePercent);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      className="bonus-policy-dialog-root"
      BackdropProps={{
        className: "bonus-policy-dialog-backdrop",
      }}
      PaperProps={{
        className: "bonus-policy-dialog-paper bg-inputbox-color",
        sx: {
          backgroundColor: "var(--inputbox-color, #1a1a1a)",
          backgroundImage: "none",
        },
      }}
    >
      <div className="bonus-policy-dialog bg-inputbox-color">
        <div className="bonus-policy-dialog__header">
          <button
            type="button"
            className="bonus-policy-dialog__back"
            onClick={onClose}
            aria-label={t("common.back")}
          >
            <ArrowBackIcon />
          </button>
          <h2 className="bonus-policy-dialog__title">
            {t(policyKey("title"))}
          </h2>
        </div>

        <div className="bonus-policy-dialog__content">
          <ul className="bonus-policy-dialog__list">
            <li className="bonus-policy-dialog__item">
              <span className="bonus-policy-dialog__bullet" aria-hidden="true" />
              <p className="bonus-policy-dialog__text">{t(policyKey("point1"))}</p>
            </li>
            <li className="bonus-policy-dialog__item">
              <span className="bonus-policy-dialog__bullet" aria-hidden="true" />
              <p className="bonus-policy-dialog__text">
                {t(policyKey("point2Prefix"))}
                <strong>{getPolicyTextWithPercent("point2Highlight")}</strong>
                {t(policyKey("point2Middle"))}
                <strong>{t(policyKey("point2MainBalance"))}</strong>
                {t(policyKey("point2Suffix"))}
              </p>
            </li>
            <li className="bonus-policy-dialog__item">
              <span className="bonus-policy-dialog__bullet" aria-hidden="true" />
              <p className="bonus-policy-dialog__text">{t(policyKey("point3"))}</p>
            </li>
            <li className="bonus-policy-dialog__item">
              <span className="bonus-policy-dialog__bullet" aria-hidden="true" />
              <p className="bonus-policy-dialog__text">{t(policyKey("point4"))}</p>
            </li>
          </ul>
        </div>
      </div>
    </Dialog>
  );
};

export default BonusPolicyDialog;
